import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { LegendItem } from './legend-item';

@Component({
  selector: 'pcs-legend',
  templateUrl: './legend.component.html',
  styleUrls: ['./legend.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LegendComponent  {
  @Input() legendItems: LegendItem[][];
}
